<template>
  <div class="about">
    <nav-header :navs="7" :navsitems="21" />
    <div class="contents">
      <div class="in-banner">
        <!--       http://www.jiukaist.com/images/banner/11.png -->
<!--        ../../assets/img/anj_new_company_img.jpg-->
        <img
            src="../../assets/image/2.png"
            width="100%"
            height="auto"
        />
      </div>

      <transition>
        <div class="pageBox waps">
          <div class="pagetit">公司简介</div>
          <div class="gsjs clearfix animation srcospcur">
            <div class="imgs">
              <img
                  src="../../assets/image/0.png"
                  width="100%"
              />
            </div>
            <div class="txts">
              台州安耐杰电⼒设备有限公司成⽴于2011年，是⼀家致⼒于⽆功补偿、电能质量、智慧物联领域的研发、⽣产和销售的国家⾼新技术企业，
              主要产品有：智能电容器、智能抑谐式电容器、电⼒电容器、电抗器、复合开关、动态投切开关等⽆功补偿产品；低电压调节、谐波治理、动静态混
              合补偿、⾼压并联⾃动补偿等成套补偿装置；静⽌⽆功发⽣器（SVG）、有源电⼒滤波器（APF）、三相不平衡矫正（SPC）等电能质量产品；智能嵌
              ⼊式、导轨式电⼒仪表、智慧电⼒采集终端、物联型传感器、综合能源管理平台等智慧物联产品。</div>
          </div>
        </div>
      </transition>

      <transition>
        <div class="pageBox waps">
          <div class="pagetits">研发实力</div>

          <div class="gsjs clearfix animation srcospcur">
            <div class="imgs">
              <img
                  src="../../assets/image/13.png"
                  width="100%"
              />
            </div>
            <div class="txts">
              公司拥有一支年纪轻、素质高、肯吃苦的科研队伍，具有十余年无功补偿和电能质量产品的研发经验，并配备了国内外先进的测试仪器、设备。我们不但具备产品自主研发能力，同时也是产品制造商，拥有完整的无功补偿、电能质量治理系列产品研发、设计与制造能力，该综合能力决定了我们深刻理解配电系统无功补偿及电能质量问题，能够快速响应用户需求，并提供优越的方案以及无可比拟的竞争优势。
            </div>
          </div>
        </div>
      </transition>

      <transition>
        <div class="pageBox waps">
          <div class="pagetits">公司荣誉 <span class="lookmore"  @click="goPages('/company/honor')">查看更多</span></div>
          <div class="gsjs clearfix animation srcospcur">
            <div class="imgs">
              <img
                  src="../../assets/image/10.png"
                  width="100%"
              />
            </div>
            <div class="txts">
              先后荣获：国家⾼新技术企业、国家级“专精特新”⼩巨⼈企业、国家科技型中⼩企业、省专精特新中⼩企业、省“守合同重信⽤”AAA级企业、
              省信⽤管理⽰范企业、电⼒⼯业百强榜“电能质量⼗强企业”、“⽆功补偿⼗强企业”、台州市企业技术中⼼、台州市⾼新技术企业研究开发中⼼、椒江区亩均产值领跑者企业等各种荣誉；
            </div>
            <div class="txts">
              陆续通过ISO9001质量管理三体系认证、两化融合管理体系认证、知识产权管理体系认证、三级安全⽣产标准化企业认证等；公司各项产品认证⻬全，均已取得CCC、CQC等⾏业认证证书；
            </div>
            <div class="txts">
              多项产品荣获:浙江省⾸台（套）产品认定、浙江制造“品”字标认证、浙江制造“精品”、浙江省⼯业新产品鉴定、市级⾸台（套）产品等多项荣誉证书。
            </div>
          </div>
        </div>
      </transition>

      <transition>
        <div class="pageBox waps">
          <div class="pagetits">公司理念</div>
          <div class="gsjs clearfix animation srcospcur">
            <div class="imgs">
              <img
                  src="../../assets/image/7.png"
                  width="100%"
              />
            </div>
            <div class="txts">
              公司自成立以来，坚持以向社会提供清洁能源和绿色电力为己任，专注于电能质量与无功补偿技术，不断提高能源利用率，追求在无功补偿和电能质量领域的领头地位，致力于不断创造先进技术和产品，并建立了完善的技术研发、生产制造、市场销售及工程服务的整套质量管理体系。
            </div>
            <div class="txts">
              我们始终以用户的需求为目标，为您提供性能稳定的产品和完善的售后服务，以此回报客户信任。
            </div>
          </div>
        </div>
      </transition>
    </div>
    <nav-footer />
  </div>
</template>
<script>
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: "about",
  data() {
    return {};
  },
  components: {
    NavHeader,
    NavFooter,
  },
  mounted() {},
  created() {
    document.documentElement.scrollTop = "0px";
  },
  methods: {
    goPages(val){
      this.$router.push(val);
    }
  },
};
</script>

<style lang='scss' scoped>
.about {
  width: 100%;
  overflow: hidden;
  margin: 0px auto;
  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }
  .v-enter-active {
    transition: all 1s ease;
  }
  .contents {
    width: 100%;
    min-width: 1350px;
    overflow: hidden;
    margin: 0px auto;
    padding-top: 75px;
    .waps {
      width: 90%;
      max-width: 1200px;
      overflow: hidden;
      margin: 0 auto;
    }
    .pageBox {
      padding: 4% 0 2%;
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      .gsjs {
        transform: translate(0, 0px);
        opacity: 1;
        transition: 1.3s;
        -webkit-transition: 1.3s;
        .imgs {
          float: left;
          width: 420px;
          overflow: hidden;
        }

      }
      .txts {
        float: right;
        width: calc(100% - 480px);
        line-height: 2em;
        font-family: 微软雅黑;
        font-size: 16px;
        color: #000000;
      }
      .txt {
        float: right;
        width: calc(100% - 480px);
        line-height: 1.5em;
      }
      .pagetits {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3%;
        color: #333333;
        position: relative;
      }
      .lookmore{
        padding: 10px;
        border: 1px solid #1d8d3b;
        font-size: 16px;
        font-weight: bold;
        color: #1d8d3b;
        text-align: center;
        border-radius: 5px;
        display: inline-block;
        cursor: pointer;
        position: absolute;
        top: -10px;
        right: 0;
      }
      .pagetit {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3.5%;
        color: #333333;
      }
    }
    .in-banner {
      width: 100%;
      height: 400px;
      overflow: hidden;
      margin: 0px auto;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  @media screen and(max-width:768px) {
    .contents {
      padding-top: 60px !important;
      min-width: unset!important;
	  min-height: 600px;
    }
    .pageBox{
      padding: 10px 0!important;
      width: calc(100% - 20px)!important;
    }
    .pagetit{
      font-size: 20px!important;
    }
    .imgs{
      float:unset!important;
      width: 100%!important;
    }
    .txt{
      float: unset!important;
      width: 100%!important;
      text-indent: 2rem;
      span{
        font-size: 14px!important;
      }
    }
    .lookmore{
      padding: 0 10px!important;
      height: 30px;
      line-height: 30px;
      top: 0!important;
    }
    .pageBox{
      .gsjs{
        .txts{
          float: unset!important;
          width: 100%!important;
          font-size: 14px!important;
          text-indent: 2rem;
        }
      }
    }


  }

}
</style>
